import { notContainsOnlySpaces } from "../../../utils";

export const validationTTSIntentInput = (fieldValues, temp) => {
  if ("values" in fieldValues) {
    temp.values = notContainsOnlySpaces(fieldValues.values)
      ? ""
      : "This field is required.";
  }

  if ("indexValue" in fieldValues) {
    if (fieldValues.indexValue === null) {
      temp.indexValue = "This field is required.";
    } else if (fieldValues.indexValue === "") {
      temp.indexValue = "This field is required.";
    } else {
      temp.indexValue = "";
    }

    if (isNaN(fieldValues.indexValue)) {
      temp.indexValue = "field must be a number";
    }
  }

  return temp;
};

export const validationTTSContextInput = (fieldValues, temp) => {
  if ("contextName" in fieldValues) {
    temp.contextName = notContainsOnlySpaces(fieldValues.contextName)
      ? ""
      : "This field is required.";
  }

  if ("contextNamespace" in fieldValues) {
    temp.contextNamespace = notContainsOnlySpaces(fieldValues.contextNamespace)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationTTSColorInput = (fieldValues, temp) => {
  if ("hexCode" in fieldValues) {
    temp.hexCode = notContainsOnlySpaces(fieldValues.hexCode)
      ? ""
      : "This field is required.";
  }

  // if ("name" in fieldValues) {
  //   temp.name = notContainsOnlySpaces(fieldValues.name)
  //     ? ""
  //     : "This field is required.";
  // }

  return temp;
};
export const validationTTSEventInput = (fieldValues, temp) => {
  if ("eventName" in fieldValues) {
    temp.eventName = notContainsOnlySpaces(fieldValues.eventName)
      ? ""
      : "This field is required.";
  }

  if ("eventNamespace" in fieldValues) {
    temp.eventNamespace = notContainsOnlySpaces(fieldValues.eventNamespace)
      ? ""
      : "This field is required.";
  }

  return temp;
};
export const validationTTSSkillInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  return temp;
};
